if (!customElements.get('makri-sticky-atc')) {
  customElements.define(
    'makri-sticky-atc',
    class MakriStickyAtc extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(min-width: 750px)').matches) return;

        this.button = this.querySelector('.makri-sticky-atc__button');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.variantEl = this.querySelector('[data-sticky-variant]');
        this.variants = JSON.parse(this.querySelector('[data-sticky-variants]')?.textContent || '{}');
        this.chosen = this.dataset.singleVariant === 'true';
        this.available = true;

        // Dawn varyant değişince variant-selects öğesini yeniden çiziyor: referans tutma, her seferinde bul.
        this.pickerId = `variant-selects-${this.dataset.sectionId}`;
        this.onPickerChange = (event) => {
          if (event.target.closest(`#${this.pickerId}`)) this.markChosen();
        };
        document.addEventListener('change', this.onPickerChange);
        this.button.addEventListener('click', () => this.onClick());

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.sectionId) return;
            this.update(data.variant);
          });
        }

        const mainButton = document.getElementById(this.dataset.buttonId);
        if (!mainButton) return;
        this.observer = new IntersectionObserver(([entry]) => this.toggle(!entry.isIntersecting));
        this.observer.observe(mainButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
        if (this.onPickerChange) document.removeEventListener('change', this.onPickerChange);
        document.body.classList.remove('makri-sticky-atc-open');
      }

      toggle(visible) {
        this.hidden = !visible;
        document.body.classList.toggle('makri-sticky-atc-open', visible);
      }

      markChosen() {
        this.chosen = true;
        this.render();
      }

      update(variant) {
        const data = variant && this.variants[variant.id];
        this.available = Boolean(data && data.available);
        if (data) {
          this.priceEl.textContent = data.price;
          if (this.variantEl) this.variantEl.textContent = data.title;
        }
        this.markChosen();
      }

      render() {
        this.button.disabled = !this.available;
        if (!this.available) {
          this.button.textContent = this.button.dataset.soldOutLabel;
        } else {
          this.button.textContent = this.chosen ? this.button.dataset.addLabel : this.button.dataset.chooseLabel;
        }
      }

      onClick() {
        const picker = document.getElementById(this.pickerId);
        if (!this.chosen && picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          picker.querySelector('input:checked, select')?.focus({ preventScroll: true });
          this.markChosen();
          return;
        }
        document.getElementById(this.dataset.buttonId)?.click();
      }
    }
  );
}
